<template>
    <div class="field-iconstyle">
        <ul class="field-iconstyle__list">
            <li
                v-for="(iconstyles__value, iconstyles__key) in getIconstyles"
                v-bind:key="id + '_' + iconstyles__key"
                class="field-iconstyle__list-item"
            >
                <input
                    type="radio"
                    :id="id + '_' + iconstyles__key"
                    v-model="simpleFieldModel"
                    :value="iconstyles__key"
                    class="field-iconstyle__input"
                />
                <label :for="id + '_' + iconstyles__key" class="field-iconstyle__label">
                    <span class="field-iconstyle__pseudo-radio"></span>
                    <img
                        width="80"
                        ref="svginject"
                        v-bind:src="
                            generateMediaUrl({
                                path: 'static/ui/iconstyles/' + iconstyles__value.id + '.svg'
                            })
                        "
                        alt=""
                        class="field-iconstyle__icon"
                    />
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import pushid from 'pushid';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';
import SVGInject from '@iconfu/svg-inject';

export default {
    data() {
        return {
            id: pushid()
        };
    },
    components: {},
    methods: {},
    computed: {
        ...mapGetters(['getIconstyles', 'generateMediaUrl'])
    },
    mounted() {
        SVGInject(this.$refs.svginject);
    },
    mixins: [SimpleFieldMixin],
    props: {}
};
</script>
